/**
 * @param {number | null} [maxWidth] max width
 * @returns {import('react').CSSProperties} max width style
 */
export function getMaxWidth(maxWidth) {
  if (maxWidth === undefined || maxWidth === null) {
    return;
  }

  return {
    maxWidth: maxWidth
  };
}